import {
  ChangeDetectionStrategy,
  Component, HostBinding,
  Input,
} from '@angular/core';

@Component({
  selector: 'int-skeleton',
  templateUrl: './int-skeleton.component.html',
  styleUrls: ['./int-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IntSkeletonComponent {
  @Input() height: string = '1.8rem';
  @Input() rounded: boolean = false;
  @Input() width = '100%';
  @Input() linesAmount = 1;
  @Input() delay = 0;

  @HostBinding('style.width')
  get rowWidth() {
    return this.rounded ? this.height : this.width;
  }

  get minWidth() {
    return this.rounded ? this.height : this.width;
  }

  get skeletonHeight() {
    return this.linesAmount > 1 ? 'auto' : this.height;
  }

  getLinesArray(): number[] {
    const arr = [];
    for (let i = 0; i < this.linesAmount; i++) {
      arr.push(i);
    }
    return arr;
  }
}
